// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file booking/v1/booking_detail.proto (package booking.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { CO2Emission, Fare, Passenger, Price, RentalVehicleDriver, Transport, TransportAgency, TransportLeg } from "../../mobility/v1/common_pb";
import { file_mobility_v1_common } from "../../mobility/v1/common_pb";
import type { VehicleProperties } from "../../mobility/v1/vehicle_pb";
import { file_mobility_v1_vehicle } from "../../mobility/v1/vehicle_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file booking/v1/booking_detail.proto.
 */
export const file_booking_v1_booking_detail: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_duration, file_google_protobuf_timestamp, file_mobility_v1_common, file_mobility_v1_vehicle]);

/**
 * Ancillary - optional add-on available for selection during booking (e.g. luggage, bike, bike reservation).
 *
 * @generated from message booking.v1.Ancillary
 */
export type Ancillary = Message<"booking.v1.Ancillary"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: mobility.v1.Price price_per_unit = 3;
   */
  pricePerUnit?: Price;

  /**
   * @generated from field: int32 max_quantity = 4;
   */
  maxQuantity: number;
};

/**
 * Describes the message booking.v1.Ancillary.
 * Use `create(AncillarySchema)` to create a new message.
 */
export const AncillarySchema: GenMessage<Ancillary> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking_detail, 0);

/**
 * TrainBooking - transport-specific data for a train booking, populated as soon as a prebook succeeds.
 *
 * @generated from message booking.v1.TrainBooking
 */
export type TrainBooking = Message<"booking.v1.TrainBooking"> & {
  /**
   * @generated from field: mobility.v1.Transport transport = 1;
   */
  transport?: Transport;

  /**
   * @generated from field: repeated booking.v1.TrainRecapSegment segments = 2;
   */
  segments: TrainRecapSegment[];

  /**
   * @generated from field: repeated mobility.v1.Fare selected_fares = 3;
   */
  selectedFares: Fare[];

  /**
   * @generated from field: repeated booking.v1.Ancillary available_ancillaries = 4;
   */
  availableAncillaries: Ancillary[];

  /**
   * @generated from field: repeated booking.v1.SelectedAncillary selected_ancillaries = 5;
   */
  selectedAncillaries: SelectedAncillary[];

  /**
   * @generated from field: mobility.v1.CO2Emission co2_emission = 6;
   */
  co2Emission?: CO2Emission;

  /**
   * Provider-assigned booking reference (e.g. PNR).
   *
   * @generated from field: optional string booking_reference = 7;
   */
  bookingReference?: string;
};

/**
 * Describes the message booking.v1.TrainBooking.
 * Use `create(TrainBookingSchema)` to create a new message.
 */
export const TrainBookingSchema: GenMessage<TrainBooking> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking_detail, 1);

/**
 * TrainRecapSegment - per-segment confirmation details for a train booking.
 *
 * @generated from message booking.v1.TrainRecapSegment
 */
export type TrainRecapSegment = Message<"booking.v1.TrainRecapSegment"> & {
  /**
   * @generated from field: mobility.v1.Transport transport = 1;
   */
  transport?: Transport;

  /**
   * @generated from field: mobility.v1.TransportLeg leg = 2;
   */
  leg?: TransportLeg;

  /**
   * @generated from field: mobility.v1.Price price = 3;
   */
  price?: Price;

  /**
   * @generated from field: string logo = 4;
   */
  logo: string;

  /**
   * @generated from field: string train_name = 5;
   */
  trainName: string;

  /**
   * @generated from field: string train_number = 6;
   */
  trainNumber: string;

  /**
   * @generated from field: repeated mobility.v1.Passenger passengers = 7;
   */
  passengers: Passenger[];

  /**
   * Provider segment id, as accepted by TrainRefundParams.segment_ids.
   *
   * @generated from field: string id = 8;
   */
  id: string;
};

/**
 * Describes the message booking.v1.TrainRecapSegment.
 * Use `create(TrainRecapSegmentSchema)` to create a new message.
 */
export const TrainRecapSegmentSchema: GenMessage<TrainRecapSegment> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking_detail, 2);

/**
 * TaxiBooking - transport-specific data for a taxi booking, populated as soon as a prebook succeeds.
 *
 * @generated from message booking.v1.TaxiBooking
 */
export type TaxiBooking = Message<"booking.v1.TaxiBooking"> & {
  /**
   * @generated from field: mobility.v1.Transport transport = 1;
   */
  transport?: Transport;

  /**
   * @generated from field: mobility.v1.TransportLeg leg = 2;
   */
  leg?: TransportLeg;

  /**
   * @generated from field: mobility.v1.Price price = 3;
   */
  price?: Price;

  /**
   * @generated from field: mobility.v1.TransportAgency agency = 4;
   */
  agency?: TransportAgency;

  /**
   * @generated from field: string label = 5;
   */
  label: string;

  /**
   * @generated from field: int32 max_passenger_capacity = 6;
   */
  maxPassengerCapacity: number;

  /**
   * @generated from field: int32 booked_passenger_count = 7;
   */
  bookedPassengerCount: number;

  /**
   * Message transmitted to the driver at dispatch time.
   *
   * @generated from field: optional string driver_message = 8;
   */
  driverMessage?: string;

  /**
   * @generated from field: mobility.v1.CO2Emission co2_emission = 9;
   */
  co2Emission?: CO2Emission;

  /**
   * Provider-assigned booking reference (e.g. order number).
   *
   * @generated from field: optional string booking_reference = 10;
   */
  bookingReference?: string;

  /**
   * Assigned driver and vehicle, populated once a driver has picked up the mission.
   *
   * @generated from field: optional booking.v1.TaxiDriver driver = 11;
   */
  driver?: TaxiDriver;

  /**
   * Set when no supplier took the mission: the ride has to be confirmed by phone with one of suppliers.
   *
   * @generated from field: bool offline = 12;
   */
  offline: boolean;

  /**
   * Taxi companies the mission was dispatched to, in dispatch priority order (name and phone only).
   *
   * @generated from field: repeated mobility.v1.TransportAgency suppliers = 13;
   */
  suppliers: TransportAgency[];
};

/**
 * Describes the message booking.v1.TaxiBooking.
 * Use `create(TaxiBookingSchema)` to create a new message.
 */
export const TaxiBookingSchema: GenMessage<TaxiBooking> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking_detail, 3);

/**
 * TaxiDriver - the driver and vehicle assigned to a taxi mission.
 *
 * @generated from message booking.v1.TaxiDriver
 */
export type TaxiDriver = Message<"booking.v1.TaxiDriver"> & {
  /**
   * @generated from field: string phone = 1;
   */
  phone: string;

  /**
   * @generated from field: string vehicle_brand = 2;
   */
  vehicleBrand: string;

  /**
   * @generated from field: string vehicle_model = 3;
   */
  vehicleModel: string;

  /**
   * @generated from field: string vehicle_color = 4;
   */
  vehicleColor: string;

  /**
   * @generated from field: string vehicle_plate = 5;
   */
  vehiclePlate: string;

  /**
   * How long until the driver reaches the pickup point, if known.
   *
   * @generated from field: optional google.protobuf.Duration time_to_pickup = 6;
   */
  timeToPickup?: Duration;
};

/**
 * Describes the message booking.v1.TaxiDriver.
 * Use `create(TaxiDriverSchema)` to create a new message.
 */
export const TaxiDriverSchema: GenMessage<TaxiDriver> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking_detail, 4);

/**
 * RentalVehicleBooking - transport-specific data for a rental vehicle booking, populated as soon as a prebook succeeds.
 *
 * @generated from message booking.v1.RentalVehicleBooking
 */
export type RentalVehicleBooking = Message<"booking.v1.RentalVehicleBooking"> & {
  /**
   * @generated from field: mobility.v1.Transport transport = 1;
   */
  transport?: Transport;

  /**
   * @generated from field: mobility.v1.TransportLeg leg = 2;
   */
  leg?: TransportLeg;

  /**
   * @generated from field: mobility.v1.Price price = 3;
   */
  price?: Price;

  /**
   * @generated from field: mobility.v1.TransportAgency agency = 4;
   */
  agency?: TransportAgency;

  /**
   * @generated from field: mobility.v1.VehicleProperties vehicle_properties = 5;
   */
  vehicleProperties?: VehicleProperties;

  /**
   * @generated from field: string vehicle_label = 6;
   */
  vehicleLabel: string;

  /**
   * @generated from field: string image_url = 7;
   */
  imageUrl: string;

  /**
   * Booking terms: cancellation policy, fuel, mileage, deposit, etc. (Markdown).
   *
   * @generated from field: string booking_conditions = 8;
   */
  bookingConditions: string;

  /**
   * @generated from field: mobility.v1.RentalVehicleDriver driver = 9;
   */
  driver?: RentalVehicleDriver;

  /**
   * Instructions regarding advance payment or deposit required at pickup.
   *
   * @generated from field: optional string advance_payment_message = 10;
   */
  advancePaymentMessage?: string;

  /**
   * @generated from field: mobility.v1.CO2Emission co2_emission = 11;
   */
  co2Emission?: CO2Emission;

  /**
   * Provider-assigned booking reference (e.g. order number).
   *
   * @generated from field: optional string booking_reference = 12;
   */
  bookingReference?: string;

  /**
   * Representative model the category stands for, e.g. "Peugeot e-208"; the vehicle actually
   * handed over is this one or an equivalent.
   *
   * @generated from field: string equivalent_model = 13;
   */
  equivalentModel: string;

  /**
   * Set once the return was pushed back after booking (see ExtendRentalVehicle).
   *
   * @generated from field: bool extended = 14;
   */
  extended: boolean;
};

/**
 * Describes the message booking.v1.RentalVehicleBooking.
 * Use `create(RentalVehicleBookingSchema)` to create a new message.
 */
export const RentalVehicleBookingSchema: GenMessage<RentalVehicleBooking> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking_detail, 5);

/**
 * TrainPrebook - data required to hold a train option.
 *
 * @generated from message booking.v1.TrainPrebook
 */
export type TrainPrebook = Message<"booking.v1.TrainPrebook"> & {
  /**
   * @generated from field: optional google.protobuf.Timestamp train_search_expires_at = 1;
   */
  trainSearchExpiresAt?: Timestamp;

  /**
   * @generated from field: repeated booking.v1.SelectedAncillary selected_ancillaries = 2;
   */
  selectedAncillaries: SelectedAncillary[];

  /**
   * @generated from field: repeated mobility.v1.Passenger passengers = 3;
   */
  passengers: Passenger[];

  /**
   * @generated from field: repeated booking.v1.SelectedSeatPreference selected_seat_preferences = 4;
   */
  selectedSeatPreferences: SelectedSeatPreference[];

  /**
   * Exact coach/seat requested (e.g. to sit next to a companion), applied to every passenger and
   * segment. Takes priority over any selected_seat_preferences once submitted to the provider.
   *
   * @generated from field: optional booking.v1.SelectedSeatAssignment seat_assignment = 5;
   */
  seatAssignment?: SelectedSeatAssignment;

  /**
   * Seats picked on a segment's seatmap, one distinct seat per passenger. Takes priority over
   * seat_assignment and selected_seat_preferences on the segments it covers.
   *
   * @generated from field: repeated booking.v1.SeatMapSelection seat_map_selections = 6;
   */
  seatMapSelections: SeatMapSelection[];
};

/**
 * Describes the message booking.v1.TrainPrebook.
 * Use `create(TrainPrebookSchema)` to create a new message.
 */
export const TrainPrebookSchema: GenMessage<TrainPrebook> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking_detail, 6);

/**
 * TaxiPrebook - data required to hold a taxi option.
 *
 * @generated from message booking.v1.TaxiPrebook
 */
export type TaxiPrebook = Message<"booking.v1.TaxiPrebook"> & {
  /**
   * @generated from field: google.protobuf.Timestamp pickup_time = 1;
   */
  pickupTime?: Timestamp;

  /**
   * @generated from field: int32 passengers_count = 2;
   */
  passengersCount: number;

  /**
   * @generated from field: string comment = 3;
   */
  comment: string;
};

/**
 * Describes the message booking.v1.TaxiPrebook.
 * Use `create(TaxiPrebookSchema)` to create a new message.
 */
export const TaxiPrebookSchema: GenMessage<TaxiPrebook> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking_detail, 7);

/**
 * RentalVehiclePrebook - data required to hold a rental vehicle option.
 *
 * @generated from message booking.v1.RentalVehiclePrebook
 */
export type RentalVehiclePrebook = Message<"booking.v1.RentalVehiclePrebook"> & {
  /**
   * @generated from field: google.protobuf.Timestamp start = 1;
   */
  start?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end = 2;
   */
  end?: Timestamp;

  /**
   * @generated from field: mobility.v1.RentalVehicleDriver driver = 3;
   */
  driver?: RentalVehicleDriver;

  /**
   * @generated from field: string comment = 4;
   */
  comment: string;
};

/**
 * Describes the message booking.v1.RentalVehiclePrebook.
 * Use `create(RentalVehiclePrebookSchema)` to create a new message.
 */
export const RentalVehiclePrebookSchema: GenMessage<RentalVehiclePrebook> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking_detail, 8);

/**
 * SelectedAncillary - an ancillary chosen by the agent with its quantity.
 *
 * @generated from message booking.v1.SelectedAncillary
 */
export type SelectedAncillary = Message<"booking.v1.SelectedAncillary"> & {
  /**
   * @generated from field: string ancillary_id = 1;
   */
  ancillaryId: string;

  /**
   * @generated from field: int32 quantity = 2;
   */
  quantity: number;
};

/**
 * Describes the message booking.v1.SelectedAncillary.
 * Use `create(SelectedAncillarySchema)` to create a new message.
 */
export const SelectedAncillarySchema: GenMessage<SelectedAncillary> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking_detail, 9);

/**
 * SelectedSeatPreference - a seat preference category value chosen by the agent for a segment.
 *
 * @generated from message booking.v1.SelectedSeatPreference
 */
export type SelectedSeatPreference = Message<"booking.v1.SelectedSeatPreference"> & {
  /**
   * @generated from field: string segment_id = 1;
   */
  segmentId: string;

  /**
   * @generated from field: string category_id = 2;
   */
  categoryId: string;

  /**
   * @generated from field: string option_id = 3;
   */
  optionId: string;
};

/**
 * Describes the message booking.v1.SelectedSeatPreference.
 * Use `create(SelectedSeatPreferenceSchema)` to create a new message.
 */
export const SelectedSeatPreferenceSchema: GenMessage<SelectedSeatPreference> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking_detail, 10);

/**
 * SeatMapSelection - the seats picked on one segment's seatmap. seats[i] goes to passengers[i] of
 * the enclosing TrainPrebook: providers reject the same seat assigned to two passengers.
 *
 * @generated from message booking.v1.SeatMapSelection
 */
export type SeatMapSelection = Message<"booking.v1.SeatMapSelection"> & {
  /**
   * @generated from field: string segment_id = 1;
   */
  segmentId: string;

  /**
   * @generated from field: repeated booking.v1.SelectedSeatAssignment seats = 2;
   */
  seats: SelectedSeatAssignment[];
};

/**
 * Describes the message booking.v1.SeatMapSelection.
 * Use `create(SeatMapSelectionSchema)` to create a new message.
 */
export const SeatMapSelectionSchema: GenMessage<SeatMapSelection> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking_detail, 11);

/**
 * SelectedSeatAssignment - an exact coach/seat requested by the agent (e.g. to sit next to a
 * companion), rather than a category preference.
 *
 * @generated from message booking.v1.SelectedSeatAssignment
 */
export type SelectedSeatAssignment = Message<"booking.v1.SelectedSeatAssignment"> & {
  /**
   * @generated from field: string coach_number = 1;
   */
  coachNumber: string;

  /**
   * @generated from field: string seat_number = 2;
   */
  seatNumber: string;
};

/**
 * Describes the message booking.v1.SelectedSeatAssignment.
 * Use `create(SelectedSeatAssignmentSchema)` to create a new message.
 */
export const SelectedSeatAssignmentSchema: GenMessage<SelectedSeatAssignment> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking_detail, 12);

